import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class InfoService {
  loadingListener = new Subject();
  errorListener = new Subject();
}
